<div class="inbox-main-container mb-5">
    <div class="inbox-container">
        <ul class="ltms-tabs">
            <li class="ltms-tab" [ngClass]="{'ltms-active-tab': activeTab.key == tab.key || !activeTab.key}" *ngFor="let tab of tabs" (click)="changeTab(tab)">{{tab.name}}</li>
        </ul>
        <div class="inbox-tab-content" *ngIf="activeTab.key == 'all_responses'">
            <litmus-feed-list-view [isAccountFeeds]="true"></litmus-feed-list-view>
        </div>
        <!-- <div class="inbox-tab-content" *ngIf="activeTab.key == 'priority_inbox'" >
            <div class='tab-container_2 justify-content-center'>
                <div class="priority-tab-content text-center pt-5 mt-5">Content will be added in the future</div>
            </div>
        </div> -->
        <div class="inbox-tab-content" *ngIf="activeTab.key == 'verbatim'">
            <div class='tab-container_2 justify-content-center'>
                <app-verbatim-home [isAccountLevel]="true"></app-verbatim-home>
            </div>
        </div>
      
    </div>
</div>